enum OperatingLeaseItemTypeEnum
{
    ACCESSORY = "ACCESSORY",
    LEASED_GOODS = "LEASED_GOODS",
    SHIPPING_FEE = "SHIPPING_FEE",
}

export default OperatingLeaseItemTypeEnum;
